<template>
    <div class="information">
        <div class="contain" id='proudct1'>
            <div class="contain-header" style="margin-top: 40px;box-sizing: border-box;padding: 40px 0 40px 0;
            ">
                <div class="con">
                    <p style="color: red;">
                        尊敬的投标人您好，我们已经收集到您为招标项目《{{this.$route.query.tenProjName}}》，项目编号《{{this.$route.query.tenProjCode}}》投保投标保证保险的需求。您的保险期间为本招标项目开标日期起至投标文件有效期止，
                        保费{{this.$route.query.premium}}元。请使用对公账户将保费支付至下方账户，我们将在收到保费后三个工作日内完成出单。请您在付款时备注下方订单编号信息，谢谢。
                    </p>
                    <span></span>
                </div>
            </div>
        </div>
        <div class="contain" id='proudct1'>
            <div class="contain-header" style="margin-top: 40px;box-sizing: border-box;padding: 40px 0 40px 0;
            ">
                <div class="con">
                    <p>订单编号：{{this.$route.query.id}}</p>
                    <p>单位名称：金晟保险经纪有限公司</p>
                    <p> 账 号：001201206040001</p>
                    <p> 联行号：102521000298</p>
                    <p>开户银行：中国工商银行武汉市水果湖支行</p>
                    <p>付款过程中有任何问题请拨打以下电话13321180765，我们将竭诚为您服务</p>
                    <p style="color: red;font-size: 2rem;">您已提交信息，请截图保存此页面内容</p>
                    <span></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectList: {
                    settlementDate: null,
                    name: null,
                    code: null,
                    personname: null,
                    personbiaohao: null,
                    personbiaohao1: null,
                    personname1: null,
                    number: null,
                    qian: null,
                },
                rules: {
                    customerType: []
                },
                customer_typelist: []
            }
        }
    }
</script>
<style scoped>
    .row {
        width: 100%;
        margin: 0 auto;
    }

    .width_100 {
        width: 100%;
        font-size: 2rem;
    }

    .contain {
        width: 100%;
    }

    .contain .contain-header {
        width: 95%;
        margin: 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 26px 34px 0px rgba(171, 171, 171, 0.12);
        border-radius: 10px;
        margin: 0 auto;
    }

    .contain .con {
        width: 100%;
        position: relative;
        margin: 40px 30px;
    }

    .contain .con p {
        width: 90%;
        font-size: 1.45rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 36px;
        position: relative;
        z-index: 10;
    }

    .row {
        width: 100%;
        margin: 2rem auto;
    }

    .width_100 {
        width: 100%;
        font-size: 2rem;
    }

    /deep/.el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 2rem;
        color: #606266;
        line-height: 2rem;
        padding: 2rem 1rem 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    /deep/.el-input {
        position: relative;
        font-size: 2rem;
        display: inline-block;
        width: 100%;
    }

    /deep/.el-input__inner {
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 5rem;
        line-height: 5rem;
        outline: 0;
        padding: 0 2rem;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }

    /deep/.el-select-dropdown__empty {
        padding: 10px 0;
        margin: 0;
        text-align: center;
        color: #999;
        font-size: 2rem;
    }
</style>